import { render, staticRenderFns } from "./RewardsList.vue?vue&type=template&id=cccacc08&scoped=true&"
import script from "./RewardsList.vue?vue&type=script&lang=ts&"
export * from "./RewardsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cccacc08",
  null
  
)

export default component.exports